import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerBaseHeightListItem = (props) => {
    const { visualizerBaseHeight, updateVisualizerSettings, maxBaseHeight } = props;
    
    const onBaseHeightChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ baseHeight: value });
    };
    
    return (
        <SliderListItem
            title='Base Height'
            value={visualizerBaseHeight}
            displayMultiplier={1}
            min={0}
            max={maxBaseHeight}
            step={1}
            onValueChange={onBaseHeightChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { baseHeight: visualizerBaseHeight } = state.createPreview.present.videoSettings.visualizer;
    const { maxBaseHeight } = state.create.maxValues;

    return { 
        visualizerBaseHeight,
        maxBaseHeight
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerBaseHeightListItem);